import { lazyImportSvg } from '@/shared/utils/lazy/lazy-import-svg';

export const HeaderIcons = {
  Back: lazyImportSvg(() => import('@/assets/icons/header/back.svg')),
  Menu: lazyImportSvg(() => import('@/assets/icons/header/menu.svg')),
  Noti: lazyImportSvg(() => import('@/assets/icons/header/noti.svg')),
  Share: lazyImportSvg(() => import('@/assets/icons/header/share.svg')),
};

export default HeaderIcons;
